import { emlformat } from './lib/eml-format';

export default emlformat;
